import "./SplitToggle.scss";

export type SplitToggleOption<T extends string | number> = {
  value: T;
  label: string;
};

type SplitToggleProps<T extends string | number> = {
  value: T;
  onChange: (value: T) => void;
  options: readonly [SplitToggleOption<T>, SplitToggleOption<T>];
  ariaLabel: string;
  id?: string;
};

const SplitToggle = <T extends string | number>({
  value,
  onChange,
  options,
  ariaLabel,
  id,
}: SplitToggleProps<T>) => (
  <div className="split-toggle" role="group" aria-label={ariaLabel}>
    {options.map((option) => (
      <button
        key={String(option.value)}
        type="button"
        className={`split-toggle__btn${value === option.value ? " active" : ""}`}
        onClick={() => onChange(option.value)}
        id={id ? `btn-${option.value}-${id}` : undefined}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export type ChartPeriod = 7 | 30;

export const CHART_PERIOD_OPTIONS: readonly [
  SplitToggleOption<ChartPeriod>,
  SplitToggleOption<ChartPeriod>,
] = [
  { value: 7, label: "Last 7 days" },
  { value: 30, label: "Last 30 days" },
];

export type ModuleSortOrder = "worst" | "best";

export const MODULE_SORT_OPTIONS: readonly [
  SplitToggleOption<ModuleSortOrder>,
  SplitToggleOption<ModuleSortOrder>,
] = [
  { value: "best", label: "Best first" },
  { value: "worst", label: "Worst first" },
];

export default SplitToggle;
